import { ticketsConstants } from "./constants";

export const requestTickets = (data) => ({
  type: ticketsConstants.REQUEST_TICKETS,
  data
});